import React from 'react'
import styled from 'styled-components'
import Waypoint from 'react-waypoint'
import Card from './Card'
import FancyTitle from './FancyTitle'
import FancyNumber from './FancyNumber'

import { rhythm, media } from '../utils/style-utils'

import stamp from '../img/stamp.svg'
import { TweenMax, Strong } from 'gsap'

const gutter = '4em'

const ProductWrapper = styled.section`
  position: relative;
  && {
    margin: ${rhythm(5)} auto;
    ${media.tablet`
      margin: ${rhythm(10)} auto;
    `};
  }
`

const Grid = styled.section`
  ${media.tablet`
    display: flex;
    flex-wrap: wrap;
    margin-right: calc(-${gutter} / 4);
  `};
  ${media.desktop`
    margin-right: -${gutter};
  `};
`

const GridItem = styled.div`
  opacity: 0;
  ${media.tablet`
    width: 33.33%;
    display: flex;
    padding-right: calc(${gutter} / 4);
  `};

  ${media.desktop`
    padding-right: ${gutter};
  `};
`

const ProductHeader = styled.div`
  ${media.tablet`
    display: flex;
    > div {
      width: 33.33%;
      margin-left: auto;
      margin-right: 18.5%;
    }
  `};
`

const Stamp = styled.img`
  display: none;
  ${media.desktop`
      display: block;
      position: absolute;
      bottom: 70px;
      left: -70px;
      pointer-events: none;
    `};
`

const ProductOverview = class extends React.Component {
  constructor() {
    super()
    this.handleWaypointEnter = this.handleWaypointEnter.bind(this)
    this.gridItems = []
  }

  handleWaypointEnter() {
    TweenMax.staggerFromTo(
      this.gridItems,
      1,
      { y: '200', opacity: 0, delay: 0.5 },
      { y: 0, opacity: 1, ease: Strong.easeInOut },
      0.2
    )
  }

  render() {
    this.gridItems = []
    const { props } = this
    const { labels } = props
    const { edges } = props.data
    return (
      <ProductWrapper
        className="l-constrained"
        innerRef={wrapper => (this.wrapperEl = wrapper)}
      >
        <ProductHeader>
          <div>
            <FancyNumber>02</FancyNumber>
            <FancyTitle>{labels.strings.product_section_title}</FancyTitle>
          </div>
        </ProductHeader>
        <Waypoint onEnter={this.handleWaypointEnter} topOffset="100">
          <Grid>
            {edges.map((product, index) => {
              const {
                title,
                description,
                productImage,
                sampleImage,
              } = product.node.frontmatter
              const imageSrc = productImage.childImageSharp.original.src
              const sampleImageSrc = sampleImage.childImageSharp.original.src
              const cardData = {
                title,
                description,
                imageSrc,
                sampleImageSrc,
              }
              return (
                <GridItem
                  key={index}
                  className="grid-item"
                  innerRef={gridItem => this.gridItems.push(gridItem)}
                >
                  <Card
                    data={cardData}
                    orderLabel={labels.strings.order_button_label}
                  />
                </GridItem>
              )
            })}
          </Grid>
        </Waypoint>
        <Stamp src={stamp} />
      </ProductWrapper>
    )
  }
}

export default ProductOverview



// WEBPACK FOOTER //
// ./src/components/ProductOverview.js